/* eslint-disable react/prop-types */
import React from 'react';
import {
  Box,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@material-ui/core';

const MenuProps = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  PaperProps: {
    style: {
      maxHeight: 224,
      width: 250,
    },
  },
};

export default function ChipMultiSelectField({
  field: { name, value, onBlur },
  form: { setFieldValue, touched, errors },
  label,
  options = [],
  getOptionLabel = (option) => option.label,
  getOptionValue = (option) => option.value,
  onValueChange,
}) {
  const safeValue = Array.isArray(value) ? value : [];
  const error = touched[name] && errors[name];

  if (!Array.isArray(value) && value) {
    safeValue.push(value);
  }

  const setValue = (newValue) => {
    setFieldValue(name, newValue);
    if (onValueChange) onValueChange(newValue);
  };

  const handleRemove = (selectedValue, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValue(
      safeValue.filter((currentValue) => currentValue !== selectedValue)
    );
  };

  return (
    <FormControl fullWidth variant="outlined" error={Boolean(error)}>
      {label && <InputLabel id={`${name}-label`}>{label}</InputLabel>}
      <Select
        labelId={`${name}-label`}
        multiple
        style={{ height: 46 }}
        value={safeValue}
        onChange={(event) => setValue(event.target.value)}
        onBlur={onBlur}
        input={<OutlinedInput labelWidth={label ? 60 : 0} />}
        renderValue={(selected) => (
          <Box
            display="flex"
            flexWrap="nowrap"
            alignItems="center"
            style={{ overflowX: 'auto', overflowY: 'hidden' }}
          >
            {selected.map((selectedValue) => {
              const option = options.find(
                (currentOption) =>
                  getOptionValue(currentOption) === selectedValue
              );
              return (
                <Chip
                  key={selectedValue}
                  label={option ? getOptionLabel(option) : selectedValue}
                  size="small"
                  style={{ flex: '0 0 auto', height: 24, marginRight: 8 }}
                  onMouseDown={(event) => handleRemove(selectedValue, event)}
                  onDelete={(event) => handleRemove(selectedValue, event)}
                />
              );
            })}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((option) => {
          const optionValue = getOptionValue(option);
          return (
            <MenuItem key={optionValue} value={optionValue}>
              {getOptionLabel(option)}
            </MenuItem>
          );
        })}
      </Select>
      {error && (
        <FormHelperText>
          {typeof error === 'string' ? error : JSON.stringify(error)}
        </FormHelperText>
      )}
    </FormControl>
  );
}
